/**
 * Clientes nuevos con nombre y correo (spec 009-dashboard-camino, US4)
 */

import { DeltaBadge } from './DeltaBadge';
import { MetricIcon } from './MetricIcon';
import { formatNumber } from './format';
import { useCountUp } from './useCountUp';

interface NewClientsCardProps {
  current: number;
  previous: number;
  comparison: string;
}

export function NewClientsCard({ current, previous, comparison }: NewClientsCardProps) {
  const animated = useCountUp(current);
  return (
    <article className="rounded-sm border border-gray-200 bg-white p-6" aria-labelledby="new-clients-title">
      <div className="flex items-start justify-between gap-3">
        <h3 id="new-clients-title" className="text-sm font-light text-[#1e1e1e]">
          Clientes nuevos con nombre y correo
        </h3>
        <MetricIcon metric="new_clients" />
      </div>
      <p className="mt-2 text-3xl font-normal tabular-nums text-[#1e1e1e]" data-testid="new-clients-value">
        {formatNumber(Math.round(animated))}
      </p>
      <div className="mt-2">
        <DeltaBadge current={current} previous={previous} label={comparison} />
      </div>
      <p className="mt-3 text-xs font-light leading-relaxed text-[#9d9c9c]">
        Personas de la mesa, no solo quien reservó. Su primera visita a tu restaurante cae en este periodo.
      </p>
    </article>
  );
}
